import { theme } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import styled, { ThemeProvider } from 'styled-components'
import EventCount from './EventCount'

type DonutChartTooltipProps = {
  type: string
  value: number
}

const DonutChartTooltip = ({ type, value }: DonutChartTooltipProps) => {
  const { t } = useTranslation()

  return (
    <ThemeProvider theme={theme}>
      <Tooltip>
        <LightText level={2} weight="medium">
          {t('STATUS')}
        </LightText>
        <EventCount type={type} count={value} fixedWidth />
      </Tooltip>
    </ThemeProvider>
  )
}

const Tooltip = styled.div`
  background-color: ${(props) => props.theme.color.neutral.color11};
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  border-radius: 9px;
  box-shadow: 0px 0px 8px 0px rgba(34, 34, 34, 0.2);
`
const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

export default DonutChartTooltip
